/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useCallback} from 'react';
import {CVSAssetType} from '@ion/core/src/types/entities';
import {mapViewGoToOptions} from '../constants';

/**
 * Provides a hook for panning to an asset on the map.
 *
 * ```typescript
 *  import {usePanToAsset, UsePanToAssetResult} from '@ion/dls/src/maps/hooks';
 *
 *  const onPanToAsset: UsePanToAssetResult = usePanToAsset(view, asset);
 *  ...
 *  onPanToAsset(...);
 * ```
 */

export type UsePanToAssetResult = (selectedAsset?: CVSAssetType) => void

export const usePanToAsset = (view: __esri.MapView, asset: CVSAssetType): UsePanToAssetResult => {
  const onPanToAsset = useCallback((selectedAsset?: CVSAssetType) => {
    const {longitude, latitude} = selectedAsset || asset;
    view?.goTo?.({center: [longitude, latitude]}, mapViewGoToOptions);
  }, [asset, view]);

  return onPanToAsset;
};

export default usePanToAsset;
